import { render, staticRenderFns } from "./CUBAApiList.vue?vue&type=template&id=7133621f&"
import script from "./CUBAApiList.vue?vue&type=script&lang=js&"
export * from "./CUBAApiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports